// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__FDcZZ","socialButton":"Footer_socialButton__6s8Vt","nav":"Footer_nav__Gcz4_","secondaryNav":"Footer_secondaryNav__N36HU"};